import React from 'react'
import map from 'lodash/map'
import type { ComponentType } from 'react'
import { HoverContainer } from '@ztechapps/webui.menu'
import { HorizontalStack } from '@ztechapps/webui.util'
import { HoverEditButton } from './HoverEditButton'
import styles from './HoverEditCodeLinks.module.scss'

type CodeLinkValue = { _id: string; code: string; status?: string }

type HoverEditCodeLinksProps = {
  onClick: () => void
  canEdit: boolean
  values: CodeLinkValue[]
  CodeLink: ComponentType<CodeLinkValue & { target?: string }>
  /** Forwarded to every `CodeLink` — only `OrderCodeLink` reads it (every other host keeps its
   * own default). */
  target?: string
}

/** A related-records row value: the hover Edit link, then the code links (`values` mapped through
 * `CodeLink`, keyed by `_id`), wrapping and right-aligned. */
export const HoverEditCodeLinks = ({ onClick, canEdit, values, CodeLink, target }: HoverEditCodeLinksProps) => (
  <HoverContainer className={styles.container}>
    {/* The outer stack wraps: Edit's slot is a fixed `visibility`-reserved width (never 0, never
        added retroactively by hover), so it never causes a hover-triggered reflow either way, but
        a narrow column (a related-panel value column, ~143px at 1024) can't always fit
        Edit AND every code on one line. `flex-wrap` lets the whole codes group (itself a single
        nested flex item from the outer stack's own point of view — its own `flex-wrap` runs
        inside it) drop to its own line below Edit when it doesn't fit, instead of overflowing the
        column. `align-items-start`, not `-center`: centering vertically would put Edit beside the
        codes' MIDDLE line once they wrap onto more than one. */}
    <HorizontalStack gap={1} className={`flex-wrap align-items-start ${styles.safeEnd}`}>
      <HoverEditButton onClick={onClick} canEdit={canEdit} className={styles.editSlot} />
      <HorizontalStack className={`flex-wrap row-gap-1 column-gap-2 align-items-center ${styles.safeEnd}`}>
        {map(values, (value) => (
          <CodeLink key={value?._id} {...value} target={target} />
        ))}
      </HorizontalStack>
    </HorizontalStack>
  </HoverContainer>
)
